<template>
<div>
<b-modal id="modal-sm" size="md" title="Patient Coverage" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
        <div slot="default">
          <div class="alert alert-warning" role="alert">{{ MsgPopup }}</div>
        </div> 
        <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary"  size="md"  class="float-right"  @click="PatientExit"> Close </b-button>
        </div>
</b-modal>
<Subtitle  v-bind:ServiceID="this.AppServiceID">
   <template v-slot:header>
    <i class="fas fa-user-injured"></i><b>Patient Coverage:</b>
  </template> 
</Subtitle>
        <!-- <h4><small class="text-muted"><i class="fas fa-notes-medical"></i><b>Patient Coverage:</b></small></h4>   -->

<form class="card  p-0 mb-1" id="SearchForm">
  <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
        <h5><small class="text-muted"><b><i class="fas fa-search-plus"></i>Search: HSN required</b></small></h5>
  </div>
  <div class="form-row p-1">
    <div class="form-group col-sm-4">
      <label for="inputEmail4" class="label-small">HSN</label>
       <input id="UserID" @input="disableSearch" v-model="HSN" maxlength="9" placeholder="HSN" class="form-control form-control-xs">
       <div class="row" v-show="$v.HSN.$error">           
     <div class="col-sm-12">
          <small class="sml-red" v-if="!$v.HSN.required">HSN is required.</small>
          <small class="sml-red" v-if="!$v.HSN.minLength">Minimum 9 digit required.</small>
            <small class="sml-red" v-if="!$v.HSN.numeric">HSN must be a number.</small>
      </div> 
      </div>
    </div> 
    <div class="form-group col-sm-4">
      <label for="inputPassword4" class="label-small">  </label>
      <div class="mt-1">
          <button v-on:click="GetHsnInfo"  type="button" class="btn btn-primary btn-sml">  Search  </button>
      </div>
    </div> 
  </div> 
</form>

<div class="row no-gutters"> 
<div class="col-12"  v-if="Patient!=null && isValid" >
<div class="card">
<div class="card-header   d-flex align-items-center  pl-1" style="height: 2rem; text-align:center;">
<h5><small class="text-muted"><b><i class="fas fa-user-injured"></i>Patient Coverage Information </b></small></h5>
</div> 
<div class="row ml-1 mt-2">
        <div class="col-6">
                <div class="row">
                        <div class="col">
                                <strong>HSN:</strong>
                        </div>
                        <div class="col">
                                {{HSN}}
                        </div> 
                </div>
        </div>
        <div class="col-6">
                <div class="row">
                        <div class="col">
                                <strong>Name:</strong>
                        </div>
                        <div class="col">
                                {{Patient.givenName}} {{Patient.surName}}
                        </div> 
                </div>
        </div>
</div>
<div class="row ml-1" >

        <div class="col-6">
                <div class="row">
                        <div class="col">
                                <strong>DOB:</strong>
                        </div>
                        <div class="col">
                                {{DOB}}
                        </div> 
                </div>

        </div>
        <div class="col">
                <div class="row">
                        <div class="col">
                                <strong>Registry (First Nations):</strong>
                        </div>
                        <div class="col">
                                {{Patient.treatyNumber}}
                        </div> 
                </div>
        </div>
</div>
<div class="row ml-1">
        <div class="col-6">
                <div class="row">
                        <div class="col">
                                <strong>Residency:</strong>
                        </div>
                        <div class="col">
                                {{Patient.currentResidentStatus}}
                        </div> 
                </div>
        </div>
        <div class="col">
                <div class="row">
                        <div class="col">
                                <strong>Special Beneficiary:</strong>
                        </div>
                        <div class="col">
                                {{SpecialBenefits}}
                        </div> 
                </div>
        </div>
</div>
<div class="row ml-1 mb-4">
        <div class="col-6">
                <div class="row">
                        <div class="col">
                                <strong>Pall Care:</strong>
                        </div>
                        <div class="col">
                                {{Patient.pallativeCareInd}}
                        </div> 
                </div>
        </div>
        <div class="col-6">
                <div class="row">
                        <div class="col-6">
                                <strong>LTC:</strong>
                        </div>
                        <div class="col-6">
                                {{Patient.longTermCareInd}}
                        </div> 
                </div>
        </div>
</div>
</div>
</div>
 </div>  
<div class="row no-gutters mt-4" v-if="Patient!=null && isValid ">
<div class="col-6 pr-2">
        <h4><small class="text-muted"><b><i class="fas fa-question-circle"></i>Program Information: {{Patient.highestProgramCode}} is highest Priority as of: {{asOf}}
        </b></small></h4>

<PatientCovProgramInfo :Data="Patient.programInformation" ></PatientCovProgramInfo>
</div>
<div class="col-6 pr-2">
<h4><small class="text-muted"><b><i class="fas fa-history"></i>Admin: Residency History</b></small></h4>
<PatientCovResidencyInfo :Data="Patient.residencyInformation" ></PatientCovResidencyInfo>
</div>
</div> 
 </div> 
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import moment from 'moment';
import PatientCovProgramInfo from '@/components/DPEBB/Administrator/PatientCovProgramInfo.vue'
import PatientCovResidencyInfo from '@/components/DPEBB/Administrator/PatientCovResidencyInfo.vue';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators' 
import { required, minLength, maxLength, between,withParams,numeric} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

 

export default {
 props:{ 
      Type:''
    },  
  data:function(){
  return{
        HSN:'',
        MsgPopup: "",
        Patient:null,
        SpecialBenefits:'',
        isValid:false,
        DOB:'',
        asOf:'',
        isValid:false,
        showModal:false,
        searched: false,
        AppServiceID :0,
        MainTitle: 'MSSCS Administration Application',
        MainIcon:'fas fa-file-prescription',
}
        
        },
        components:{
                Card,
                CardBody,
                PatientCovProgramInfo,
                PatientCovResidencyInfo,
                Modal:Modal,
                TileNote,
                Subtitle
        },
        
        computed:{
                UserName(){
                return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
                },
        },
        methods:{
        GetHsnInfo(){

                var vm = this;
                vm.$v.$touch();
                if (!vm.$v.$invalid) {
                        var params = new URLSearchParams();
                        vm.Patient = null;
                        params.append("HSN", this.HSN);
                        axios
                        .get("SaskHealthApi/Host/GetHsnInq", {
                        headers: { Authorization: "Bearer " + localStorage.access_token },
                        params,
                        })
                        .then(function (response) {
                        vm.patient = response.data;
                        vm.loadTable();
                        vm.searched = true;                        
                        // vm.showModal = false;
                        // vm.isValid = true; 
                        })
                        .catch(function (er) {
                        console.log(er);
                        vm.Patient = [];
                        // if (er.status == 400) {
                        // //console.log("here");
                        // vm.showModal = true;
                        // vm.MsgPopup = er.data.message;
                        // } else if (er.status == 500) {
                        // vm.showModal = true;

                        // if (er.data.message != null) vm.MsgPopup = er.data.message;
                        // else
                        //         vm.MsgPopup =
                        //         "Network Related Error , Please Contact System Administrator.";
                        // }

                        if (er.response) {
                            if(er.response.status == 400)
                                {
                                        if( er.response.data.message.length)
                                        {
                                        vm.showMsg(er.response.data.message,"","HSN Search Error");

                                        }
                                }

                                else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                           
                        }
                        else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");
                     
                 
                
                 });
                                
         }
                
        },

        showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          console.log("at value " + value);
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },


        //},
        loadTable(){  
   
                var vm = this;      
                //vm.searched = false;
                vm.Patient = null;
                var params = new URLSearchParams(); 
                console.log('At Load Table Pat Cov');
                params.append('HSN', this.HSN);               
                axios.get('SaskHealthApi/Host/GetPatientCoverage', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
                .then(function (response) {
                        vm.showModal = false;
                        console.log(vm.Patient);
                        vm.Patient = response.data;
                        console.log(vm.Patient);
                        vm.SpecialBenefits = vm.Patient.specialBenefitsInformation.length==0?"N":"Y";
                        vm.DOB =moment(vm.Patient.birthDate).format('YYYY/MM/DD');
                        vm.asOf = moment(new Date()).format('YYYY/MM/DD');
                        vm.isValid = true;

                })
                .catch(function (er) {
                console.log(er);
                vm.Patient = [];
                if (er.response.status == 400) {
                        //console.log("Get Patient Cov here");
                        console.log(er.response.data.message)
                        vm.showModal = true;
                        vm.MsgPopup = er.response.data.message;                        
                } 
                else if (er.response.status == 500) {

                        // if (er.response.data.message != null) vm.MsgPopup = er.response.data.message;
                        // else
                        vm.MsgPopup =
                                "Network Related Error , Please Contact System Administrator.";
                }
                
                //vm.isValid = true;
                vm.showModal = true;
                // vm.Patient =null;
                })
        },
        disableSearch(){
        // this.tableData = [];
         this.isValid = false;
         },
        PatientExit(){
          this.showModal=false;
        
        }
        },
        validations(){
      return {

            HSN : {
              required,
              numeric,
             minLength:minLength(9),
            },
        }
      },
        created: function() {   
        this.AppServiceID = this.Type; 
         
        if(this.AppServiceID=="1")
        {
        this.MainIcon = 'fas fa-tooth';
        this.MainTitle ='Dental Application';
        }
        else if(this.AppServiceID=="2")
        {
        this.MainIcon = 'fas fa-hospital-alt';
        this.MainTitle ='Medical Application';
        }
        else if(this.AppServiceID=="3")
        {
        this.MainIcon = 'fas  fa-glasses';
        this.MainTitle ='Optical Application';
        }
        else if(this.AppServiceID=="4")
        {
        this.MainIcon = 'fas fa-assistive-listening-systems';
        this.MainTitle ='Hearing Application';
        }
        else if(this.AppServiceID=="5")
        {
        this.MainIcon = 'fas  fa-shoe-prints';
        this.MainTitle ='Podiatry Application';
        }
        else if(this.AppServiceID=="6")
        {
        this.MainIcon = 'fas fa-file-prescription';
        this.MainTitle ='MSSCS Administration Application';
        }
        }
}
</script>

<style>

</style>
